var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 600"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Icons_Selected_08_Deny"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons_Selected_08_Deny",
    clipPath: "url(#clip-Icons_Selected_08_Deny)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons_Selected_08_Deny-2",
    "data-name": "Icons_Selected_08_Deny",
    transform: "translate(-6.816 4.557)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shadow_Layer",
    transform: "translate(80.405 52.89)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 263.205,
    cy: 263.205,
    r: 263.205,
    fill: "#eaeaea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(6.816 11.585)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M62.336,439.174a8.894,8.894,0,0,1-7.16-3.75c-68.87-98.531-63.756-232.52,12.615-325.6A267.816,267.816,0,0,1,352.134,22.888a8.523,8.523,0,0,1-4.773,16.365A251.269,251.269,0,0,0,81.087,120.737c-71.6,87.28-76.37,212.405-11.592,304.8A8.68,8.68,0,0,1,67.45,437.47,10.145,10.145,0,0,1,62.336,439.174Z",
    transform: "translate(-6.816 -11.585)",
    fill: "#4c4c4c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(186.088 139.589)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M144.257,451.333a269.6,269.6,0,0,1-76.711-11.251,8.523,8.523,0,0,1,4.773-16.365,250.909,250.909,0,0,0,266.273-81.484A251.939,251.939,0,0,0,367.231,65.049a8.615,8.615,0,0,1,15.342-7.842A269.023,269.023,0,0,1,144.257,451.333Z",
    transform: "translate(-61.396 -52.527)",
    fill: "#4c4c4c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M363.285,388.818c-15-23.184-30.344-46.368-44.322-69.893-6.137-10.569-12.615-20.8-18.752-31.366,14.66-19.433,29.321-39.208,43.981-58.641C383.06,177.095,421.927,124.931,462.5,74.131c-25.57-17.388-51.482-34.435-77.052-51.823-4.432-3.068-9.546-6.137-15.342-4.773-5.114,1.364-9.205,5.8-12.615,10.228C316.918,77.541,278.051,134.137,238.5,191.414c-1.023-1.364-1.7-2.728-2.728-4.091-13.978-21.82-28.3-43.64-42.617-65.46-7.16-10.91-13.979-21.82-21.138-33.071-3.409-5.455-6.819-10.91-10.228-16.706-2.046-3.409-4.432-10.91-9.205-11.592-4.432-.341-10.228,3.068-13.638,5.455-6.137,4.091-11.933,8.183-17.729,12.615-11.933,8.183-23.866,16.706-35.8,24.889-3.75,2.728-8.183,5.8-8.864,10.569-.682,4.091,1.7,8.183,3.409,11.933,25.23,53.187,58.3,105.009,94.1,156.832C133.833,337.677,92.239,389.841,46.212,432.8c-4.091,3.75-8.523,7.5-12.274,11.933-3.068,3.409-10.228,6.137-8.183,11.251a38.363,38.363,0,0,0,4.091,7.16L87.466,516.67c4.091,3.75,8.183,7.842,13.638,9.205a8.394,8.394,0,0,0,4.091.341l2.046-1.023c8.183-5.114,14.319-13.638,20.8-20.456,7.16-7.5,13.979-15.342,20.456-23.184,26.934-32.048,51.482-66.142,77.393-98.531,3.409-4.091,6.478-8.523,9.887-12.615,20.115,27.616,40.231,55.232,59.664,82.848,4.432,6.137,11.592,19.434,20.8,14.66l70.233-30.344c6.819-3.75-3.068-15.683-5.455-19.774C375.559,407.911,369.422,398.364,363.285,388.818Z",
    transform: "translate(37.947 1.95)",
    fill: "#ff6912"
  }))))));
};
export default __webpack_public_path__ + "static/media/Icons_Selected_08_Deny.7815dcee.svg";
export { SvgComponent as ReactComponent };